export default {
    "common.Accept": "Aceitar",
    "common.Add": "Adicionar",
    "common.Cancel": "Cancelar",
    "common.Close": "Fechar",
    "common.Delete": "Eliminar",
    "common.Save": "Guardar",

    "common.accept": "aceitar",
    "common.add": "adicionar",
    "common.cancel": "cancelar",
    "common.close": "fechar",
    "common.delete": "apagar",
    "common.save": "guardar"
}